import React, { Component } from "react";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import ShemshIcon from "../../../static/icons/shemsh.png";
import AnalysisView from "./AnalysisView";
import LoadingCircular from "../../LoadingCircular";

class Shemsh extends Component {
  state = {
    open: false,
    selectedAlloy: "",
    selectedAlloyCode: "",
    isLoading: false,
    rows: [],
  };
  analysisData = [
    {
      code: "1038",
      analysis: [
        { element: "Si", min_value: "6.5", max_value: "7.5" },
        { element: "Fe", min_value: null, max_value: "0.20" },
        { element: "Cu", min_value: null, max_value: "0.10" },
        { element: "Mn", min_value: null, max_value: "0.10" },
        { element: "Mg", min_value: "0.25", max_value: "0.40" },
        { element: "Zn", min_value: null, max_value: "0.10" },
        { element: "Ti", min_value: "0.08", max_value: "0.25" },
        { element: "Ni", min_value: null, max_value: "0.05" },
        { element: "Pb", min_value: null, max_value: "0.05" },
        { element: "Sn", min_value: null, max_value: "0.05" },
        { element: "Each", min_value: "0.03" },
        { element: "Total", min_value: "0.10" },
      ],
    },
    {
      code: "1040",
      analysis: [
        { element: "Si", min_value: "8.0", max_value: "10.0" },
        { element: "Fe", min_value: null, max_value: "1.0" },
        { element: "Cu", min_value: "2.7", max_value: "3.7" },
        { element: "Mn", min_value: null, max_value: "0.60" },
        { element: "Mg", min_value: "0.10", max_value: "0.30" },
        { element: "Zn", min_value: null, max_value: "1.2" },
        { element: "Ti", min_value: null, max_value: "0.20" },
        { element: "Ni", min_value: null, max_value: "0.50" },
        { element: "Pb", min_value: null, max_value: "0.20" },
        { element: "Sn", min_value: null, max_value: "0.20" },
      ],
    },
    {
      code: "1032",
      analysis: [
        { element: "Si", min_value: "9.6", max_value: "12.0" },
        { element: "Fe", min_value: null, max_value: "1.3" },
        { element: "Cu", min_value: "1.5", max_value: "3.5" },
        { element: "Mn", min_value: null, max_value: "0.5" },
        { element: "Mg", min_value: null, max_value: "0.3" },
        { element: "Zn", min_value: null, max_value: "1.0" },
        { element: "Ni", min_value: null, max_value: "0.5" },
        { element: "Sn", min_value: null, max_value: "0.3" },
      ],
    },
    {
      code: "1037",
      analysis: [
        { element: "Si", min_value: "10.0", max_value: "13.0" },
        { element: "Fe", min_value: null, max_value: "0.6" },
        { element: "Cu", min_value: null, max_value: "1.0" },
        { element: "Mn", min_value: null, max_value: "0.5" },
        { element: "Mg", min_value: null, max_value: "0.10" },
        { element: "Zn", min_value: null, max_value: "0.1" },
        { element: "Ti", min_value: null, max_value: "0.02" },
        { element: "Ni", min_value: null, max_value: "0.1" },
        { element: "Pb", min_value: null, max_value: "0.1" },
        { element: "Sn", min_value: null, max_value: "0.05" },
        { element: "Each", min_value: "0.05" },
        { element: "Total", min_value: "0.15" },
      ],
    },
    {
      code: "1008",
      analysis: [
        { element: "Si", min_value: "4.0", max_value: "6.0" },
        { element: "Fe", min_value: null, max_value: "1.0" },
        { element: "Cu", min_value: "2.0", max_value: "4.0" },
        { element: "Mn", min_value: "0.2", max_value: "0.6" },
        { element: "Mg", min_value: null, max_value: "0.20" },
        { element: "Zn", min_value: null, max_value: "0.5" },
        { element: "Ti", min_value: null, max_value: "0.2" },
        { element: "Ni", min_value: null, max_value: "0.3" },
        { element: "Pb", min_value: null, max_value: "0.1" },
        { element: "Sn", min_value: null, max_value: "0.1" },
        { element: "Each", min_value: "0.05" },
        { element: "Total", min_value: "0.15" },
      ],
    },
    {
      code: "1007",
      analysis: [
        { element: "Si", min_value: "9.0", max_value: "11.5" },
        { element: "Fe", min_value: null, max_value: "1.0" },
        { element: "Cu", min_value: "0.7", max_value: "2.5" },
        { element: "Mn", min_value: null, max_value: "0.5" },
        { element: "Mg", min_value: null, max_value: "0.30" },
        { element: "Zn", min_value: null, max_value: "2.0" },
        { element: "Ti", min_value: null, max_value: "0.2" },
        { element: "Ni", min_value: null, max_value: "0.5" },
        { element: "Pb", min_value: null, max_value: "0.3" },
        { element: "Sn", min_value: null, max_value: "0.1" },
        { element: "Total", min_value: "0.50" },
      ],
    },
    {
      code: "1043",
      analysis: [
        { element: "Si", min_value: "9.0", max_value: "1.0" },
        { element: "Fe", min_value: null, max_value: "0.15" },
        { element: "Cu", min_value: null, max_value: "0.03" },
        { element: "Mn", min_value: null, max_value: "0.05" },
        { element: "Mg", min_value: "0.20", max_value: "0.40" },
        { element: "Zn", min_value: null, max_value: "0.07" },
        { element: "Ti", min_value: null, max_value: "0.15" },
        { element: "Each", min_value: "0.03" },
        { element: "Total", min_value: "0.10" },
      ],
    },
    {
      code: "1044",
      analysis: [
        { element: "Si", min_value: "9.0", max_value: "11.0" },
        { element: "Fe", min_value: null, max_value: "0.30" },
        { element: "Cu", min_value: null, max_value: "0.30" },
        { element: "Mn", min_value: null, max_value: "0.4" },
        { element: "Mg", min_value: "0.20", max_value: "0.50" },
        { element: "Zn", min_value: null, max_value: "0.1" },
        { element: "Ti", min_value: null, max_value: "0.15" },
        { element: "Each", min_value: "0.05" },
        { element: "Total", min_value: "0.15" },
      ],
    },
    {
      code: "1051",
      analysis: [
        { element: "Si", min_value: "10.0", max_value: "13.0" },
        { element: "Fe", min_value: null, max_value: "1.0" },
        { element: "Cu", min_value: "0.7", max_value: "1.5" },
        { element: "Mn", min_value: null, max_value: "0.5" },
        { element: "Mg", min_value: "0.8", max_value: "1.5" },
        { element: "Zn", min_value: null, max_value: "0.5" },
        { element: "Ti", min_value: null, max_value: "0.2" },
        { element: "Ni", min_value: null, max_value: "1.5" },
        { element: "Pb", min_value: null, max_value: "0.1" },
        { element: "Sn", min_value: null, max_value: "0.1" },
        { element: "Each", min_value: "0.05" },
        { element: "Total", min_value: "0.15" },
      ],
    },
    {
      code: "1042",
      analysis: [
        { element: "Si", min_value: "6.8", max_value: "8.0" },
        { element: "Fe", min_value: null, max_value: "0.80" },
        { element: "Cu", min_value: "2.3", max_value: "3.8" },
        { element: "Mn", min_value: "0.30", max_value: "0.60" },
        { element: "Mg", min_value: "0.25", max_value: "0.30" },
        { element: "Zn", min_value: null, max_value: "0.50" },
        { element: "Ti", min_value: null, max_value: "0.25" },
        { element: "Ni", min_value: null, max_value: "0.30" },
        { element: "Pb", min_value: null, max_value: "0.10" },
        { element: "Sn", min_value: null, max_value: "0.10" },
      ],
    },
    {
      code: "1041",
      analysis: [
        { element: "Si", min_value: "4.5", max_value: "6.0" },
        { element: "Fe", min_value: null, max_value: "0.80" },
        { element: "Cu", min_value: "2.8", max_value: "3.8" },
        { element: "Mn", min_value: "0.20", max_value: "0.60" },
        { element: "Mg", min_value: "0.05", max_value: "0.25" },
        { element: "Zn", min_value: null, max_value: "0.50" },
        { element: "Ti", min_value: null, max_value: "0.25" },
        { element: "Ni", min_value: null, max_value: "0.30" },
        { element: "Pb", min_value: null, max_value: "0.10" },
        { element: "Sn", min_value: null, max_value: "0.05" },
      ],
    },
    {
      code: "1039",
      analysis: [
        { element: "Si", min_value: "6.5", max_value: "7.5" },
        { element: "Fe", min_value: null, max_value: "0.20" },
        { element: "Cu", min_value: null, max_value: "0.10" },
        { element: "Mn", min_value: null, max_value: "0.10" },
        { element: "Mg", min_value: "0.45", max_value: "0.70" },
        { element: "Zn", min_value: null, max_value: "0.10" },
        { element: "Ti", min_value: "0.08", max_value: "0.25" },
        { element: "Ni", min_value: null, max_value: "0.05" },
        { element: "Pb", min_value: null, max_value: "0.05" },
        { element: "Sn", min_value: null, max_value: "0.05" },
        { element: "Each", min_value: "0.03" },
        { element: "Total", min_value: "0.10" },
      ],
    },
    {
      code: "1048",
      analysis: [
        { element: "Si", min_value: "7.5", max_value: "9.5" },
        { element: "Fe", min_value: null, max_value: "1.0" },
        { element: "Cu", min_value: "3.0", max_value: "4.0" },
        { element: "Mn", min_value: null, max_value: "0.50" },
        { element: "Mg", min_value: null, max_value: "0.10" },
        { element: "Zn", min_value: null, max_value: "2.9" },
        { element: "Ni", min_value: null, max_value: "0.50" },
        { element: "Sn", min_value: null, max_value: "0.35" },
        { element: "Total", min_value: "0.50" },
      ],
    },
    {
      code: "1033",
      analysis: [
        { element: "Si", min_value: "7.5", max_value: "9.5" },
        { element: "Fe", min_value: null, max_value: "1.3" },
        { element: "Cu", min_value: "2.0", max_value: "4.0" },
        { element: "Mn", min_value: null, max_value: "0.5" },
        { element: "Mg", min_value: null, max_value: "0.3" },
        { element: "Zn", min_value: null, max_value: "1.0" },
        { element: "Ni", min_value: null, max_value: "0.5" },
        { element: "Sn", min_value: null, max_value: "0.3" },
      ],
    },
    {
      code: "1046",
      analysis: [
        { element: "Si", min_value: "6.5", max_value: "7.5" },
        { element: "Fe", min_value: null, max_value: "0.12" },
        { element: "Cu", min_value: null, max_value: "0.10" },
        { element: "Mn", min_value: null, max_value: "0.05" },
        { element: "Mg", min_value: "0.30", max_value: "0.45" },
        { element: "Zn", min_value: null, max_value: "0.05" },
        { element: "Ti", min_value: null, max_value: "0.20" },
        { element: "Each", min_value: "0.05" },
        { element: "Total", min_value: "0.15" },
      ],
    },
    {
      code: "1031",
      analysis: [
        { element: "Si", min_value: "6.5", max_value: "7.5" },
        { element: "Fe", min_value: null, max_value: "0.15" },
        { element: "Cu", min_value: null, max_value: "0.20" },
        { element: "Mn", min_value: null, max_value: "0.10" },
        { element: "Mg", min_value: "0.30", max_value: "0.45" },
        { element: "Zn", min_value: null, max_value: "0.10" },
        { element: "Ti", min_value: null, max_value: "0.20" },
        { element: "Each", min_value: "0.05" },
        { element: "Total", min_value: "0.15" },
      ],
    },
    {
      code: "1045",
      analysis: [
        { element: "Si", min_value: "11.0", max_value: "13.0" },
        { element: "Fe", min_value: null, max_value: "0.6" },
        { element: "Cu", min_value: null, max_value: "0.10" },
        { element: "Mn", min_value: null, max_value: "0.05" },
        { element: "Mg", min_value: null, max_value: "0.05" },
        { element: "Zn", min_value: null, max_value: "0.05" },
        { element: "Ni", min_value: null, max_value: "0.05" },
        { element: "Sn", min_value: null, max_value: "0.05" },
        { element: "Total", min_value: "0.10" },
      ],
    },
    {
      code: "1030",
      analysis: [
        { element: "Si", min_value: "11.0", max_value: "13.0" },
        { element: "Fe", min_value: null, max_value: "1.0" },
        { element: "Cu", min_value: null, max_value: "1.0" },
        { element: "Mn", min_value: null, max_value: "0.35" },
        { element: "Mg", min_value: null, max_value: "0.10" },
        { element: "Zn", min_value: null, max_value: "0.40" },
        { element: "Ni", min_value: null, max_value: "0.50" },
        { element: "Sn", min_value: null, max_value: "0.15" },
        { element: "Total", min_value: "0.25" },
      ],
    },
  ];
  getAnalysis = (name, code) => {
    this.setState({ isLoading: true });

    const data = this.analysisData.find((a) => a.code === code).analysis;
    this.setState({
      rows: data,
      isLoading: false,
      open: true,
      selectedAlloy: name,
      selectedAlloyCode: code,
    });
  };
  render() {
    return (
      <>
        <LoadingCircular open={this.state.isLoading} />
        <AnalysisView
          open={this.state.open}
          selectedAlloy={this.state.selectedAlloy}
          selectedAlloyCode={this.state.selectedAlloyCode}
          rows={this.state.rows}
          onClose={() => {
            this.setState({ open: false });
          }}
        />
        <Typography sx={{ textAlign: "justify" }}>
          این شرکت مفتخر است اعلام نماید توانایی تولید هر نوع آلیاژ طبق
          استاندارد و یا سفارش مشتری را دارا می باشد، ضمنا برخی از آلیاژهای
          پرکاربرد در صنعت آلومینیوم در ذیل آمده است.
        </Typography>
        <List>
          {[
            { name: "AS7G03", code: "1038" },
            { name: "AS9U3", code: "1040" },
            { name: "ADC12", code: "1032" },
            { name: "LM6", code: "1037" },
            { name: "LM4", code: "1008" },
            { name: "LM2", code: "1007" },
            { name: "ALSI9MG", code: "1043" },
            { name: "ALSI10MG", code: "1044" },
            { name: "LM13", code: "1051" },
            { name: "AS7U3G", code: "1042" },
            { name: "AS5U3G", code: "1041" },
            { name: "AS7G06", code: "1039" },
            { name: "A380.1", code: "1048" },
            { name: "ADC10", code: "1033" },
            { name: "A356.2", code: "1046" },
            { name: "A356.1", code: "1031" },
            { name: "A413.2", code: "1045" },
            { name: "A413.1", code: "1030" },
          ].map((alloy, index) => (
            <div key={alloy.name}>
              <ListItem key={alloy.name}>
                <ListItemAvatar>
                  <Avatar src={ShemshIcon}></Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={alloy.name}
                  secondary={
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() => {
                        this.getAnalysis(alloy.name, alloy.code);
                      }}
                    >
                      آنالیز
                    </Button>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" />
            </div>
          ))}
        </List>
      </>
    );
  }
}

export default Shemsh;
